<template>
  <div class="period pr16 pl16">
    <div class="calendar_head">
      <button class="btn prev" @click="prevMonth"><img src="@/assets/images/calendar/prev.png" alt=""></button>
      <div class="current_date rb c5a" v-html="formatDate()">{{ formatDate() }}</div>
      <button class="btn next" @click="nextMonth"><img src="@/assets/images/calendar/next.png" alt=""></button>
    </div>

  </div>
</template>

<script>
import moment from 'moment';
import dateFormat from '@/model/dateFormat';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
    }
  },
  methods: {
    nextMonth() {
      this.$store.commit('setSalesSummaryReportCurrentMonth', moment(this.currentMonth).add(1, 'month').format('Y-MM'));
      // this.emitCurrentDate();
    },
    prevMonth() {
      this.$store.commit('setSalesSummaryReportCurrentMonth', moment(this.currentMonth).subtract(1, 'month').format('Y-MM'));
      // this.emitCurrentDate();
    },
    formatDate() {
      return dateFormat.formatDate(this.currentMonth, 'yyyy<span class="year ab">年</span>MM<span class="month ab">月</span>');
    },
  },
  computed: mapGetters(['currentMonth']),
  created() {
    // 年月がstoreにない時のみ実行（アクセス状況ページで再読み込みを防ぐため）
    if(this.currentMonth == null) {
      this.$store.commit('setSalesSummaryReportCurrentMonth', moment().format('Y-MM'));
    }
  }
}
</script>

<style lang="css" scoped>
.calendar_head {
  align-items: center;
  display: flex;
  border-bottom: 1px solid  #c9c9c9;
  justify-content: space-between;
  padding: 24px 6px 14px 6px;
}
.current_date {
  font-size: 22px;
}
.year, .month {
  font-size: 16px;
}
.year {
  margin: 0 2px;
}
.btn {
  border: none;
  background: transparent;
  padding: 0;
}
.btn img {
  width: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/wallet/SelectMonth.vue